import { Card } from 'antd';
import { NoData } from '@ui/NoData';
import { NotificationCard } from './NotificationCard';
import React from 'react';
import { useNotifications } from '@hooks';
import { USER_NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import VirtualList from 'rc-virtual-list';
const empty = React.createElement(NoData, { description: USER_NOTIFICATIONS_COPY.EMPTY });
export const NotificationCards = ({ className, height, itemHeight, wrapEmpty }) => {
    const notifications = useNotifications();
    if (!(notifications === null || notifications === void 0 ? void 0 : notifications.length)) {
        return wrapEmpty ? React.createElement(Card, null, empty) : empty;
    }
    return (React.createElement(VirtualList, { className: className, data: notifications, height: height, itemHeight: itemHeight !== null && itemHeight !== void 0 ? itemHeight : 140, itemKey: 'notificationId' }, (notification) => React.createElement(NotificationCard, { key: notification.notificationId, notification: notification })));
};
